import { FulfillmentStatus } from '../../model/type/fulfillment-status.enum';
import { OrderPaymentStatus } from '../../model/type/order-payment-status.enum';
import { OrderStatus } from '../../model/type/order-status.enum';
import { StatusTone } from '../../model/type/status-tone.type';

const ORDER_STATUS_TONES = new Map<string, StatusTone>([
  [OrderStatus.Created, 'initial'],
  [OrderStatus.Completed, 'success'],
  [OrderStatus.Fulfilled, 'success'],
  [OrderStatus.Submitted, 'progress'],
  [OrderStatus.Shipped, 'progress'],
  [OrderStatus.Pending, 'pending'],
  [OrderStatus.Processing, 'pending'],
  [OrderStatus.Hold, 'pending'],
  [OrderStatus.Unfulfilled, 'pending'],
  [OrderStatus.Default, 'pending'],
  [OrderStatus.WaitingForManualUpdate, 'pending'],
  [OrderStatus.Failed, 'failure'],
]);

const PAYMENT_STATUS_TONES = new Map<string, StatusTone>([
  [OrderPaymentStatus.Complete, 'success'],
  [OrderPaymentStatus.Pending, 'pending'],
  [OrderPaymentStatus.Preapproved, 'pending'],
  [OrderPaymentStatus.Failed, 'failure'],
]);

const FULFILLMENT_STATUS_TONES = new Map<string, StatusTone>([
  [FulfillmentStatus.Fulfilled, 'success'],
  [FulfillmentStatus.Unfulfilled, 'pending'],
]);

export const getOrderStatusTone = (status?: string | null): StatusTone =>
  ORDER_STATUS_TONES.get(status ?? '') ?? 'neutral';

export const getPaymentStatusTone = (status?: string | null): StatusTone =>
  PAYMENT_STATUS_TONES.get(status ?? '') ?? 'neutral';

export const getFulfillmentStatusTone = (status?: string | null): StatusTone =>
  FULFILLMENT_STATUS_TONES.get(status ?? '') ?? 'neutral';

export const isFailedOrder = (status?: string | null): boolean =>
  status === OrderStatus.Failed;
